import { render, staticRenderFns } from "./CostBearerEducationPaymentPreview.vue?vue&type=template&id=5700d3ce"
import script from "./CostBearerEducationPaymentPreview.vue?vue&type=script&lang=ts"
export * from "./CostBearerEducationPaymentPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports